<template>
  <md-card>
      <md-card-content class="md-layout md-gutter">

        <div class="md-layout-item md-layout md-medium-size-33 md-small-size-33 md-xsmall-size-100">
          <md-field :class="validationClass('dateFrom')">
            <label for="dateOccurred">
              <md-icon>calendar_today</md-icon>
              {{dateFrom ? '' : 'Desde'}}
            </label>
            <datetime 
              date-vv-name="dateFrom"
              v-validate="'required'"
              input-style="border: none; outline:none; width: 100%"
              type="date"
              title="Desde"
              :min-datetime="minDate"
              value-zone="America/Mexico_City"
              v-model="dateFrom" 
              :phrases="{ok: '', cancel: ''}"
              auto
            ></datetime>
              <md-button class="md-simple md-just-icon"
              @click="dateFrom = null" v-if="false">
                <md-icon>close</md-icon>
              </md-button>
          </md-field>
        </div>

        <div class="md-layout-item md-layout md-medium-size-33 md-small-size-33 md-xsmall-size-100">
          <md-field>
            <label for="dateOccurred">
              <md-icon>calendar_today</md-icon>
              {{dateTo ? '' : 'Hasta'}}
            </label>
            <datetime 
              input-style="border: none; outline:none; width: 100%"
              type="date"
              title="Hasta"
              value-zone="America/Mexico_City"
              v-model="dateTo" 
              :phrases="{ok: '', cancel: ''}"
              auto
            ></datetime>
            <md-button class="md-simple md-just-icon"
            @click="dateTo = null">
            <md-icon>close</md-icon>
          </md-button>
        </md-field>
        </div>

        <div class="md-layout-item md-layout md-medium-size-33 md-small-size-33 md-xsmall-size-100">
            <md-field>
              <label>Autopista</label>
              <md-select v-model="selectedHighway">
                <md-option :value="0">
                  Todas
                </md-option>
                <md-option v-for="highway in highways" :key="highway.id" :value="highway.id">
                  {{highway.name}}
                </md-option>
              </md-select>
            </md-field>
        </div>

        <div class="md-layout-item md-layout md-medium-size-33 md-small-size-33 md-xsmall-size-100"
        v-if="filterByReVi">
            <md-field>
              <label>Residente</label>
              <md-select v-model="selectedRevi">
                <md-option :value="0">
                  Todos
                </md-option>
                <md-option v-for="revi in revis" :key="revi.id" :value="revi.id">
                  {{revi.name}}
                </md-option>
              </md-select>
            </md-field>
        </div>

        <div class="md-layout-item md-layout md-medium-size-33 md-small-size-33 md-xsmall-size-100"
        >
          <md-radio v-model="notFinished" :value="true">Sin finalizar</md-radio>
          <md-radio v-model="notFinished" :value="false">Finalizados</md-radio>
        </div>

      </md-card-content>
    </md-card>
</template>

<script>
import { Slider, Collapse } from '@/components'
import catalogService from '@/services/catalog'
import userService from '@/services/user'
import FilterBar from '@/components/FilterBar'
import moment from 'moment'

export default {
  components: {
    Slider,
    Collapse,
    FilterBar,
  },
  data() {
    const { defaultFromDate } = this
    return {
    	dateFrom: defaultFromDate || null,
    	dateTo: null,
      selectedHighway: null,
      highways: [],
      selectedRevi: null,
      notFinished: true,
      revis: [
      ],
    }
  },
  created() {
  },
  props: {
    source: {
    	type: Array,
      required: false
    },
    filterByReVi: {
      type: Boolean,
      default: false,
    },
    minDate: {
      required: false
    },
    defaultFromDate: {
      type: String
    },
    highwaysCatalog: {
      type: Array,
      required: false
    }
  },
  watch: {
    filteredData() {
    	this.$emit('filtered', this.filteredData)
    },
    selectedRevi(value) {
      const revi = this.revis.find(revi => revi.id == value)
      this.$emit('selectedRevi', revi)
    },
    filterByReVi: {
      immediate: true,
      handler(value) {
        if (value) {
          this.fetchReVis()
        }
      },
    },
    notFinished(value) {
      this.$emit('updatedNotFinished', value)
    },
    dateFrom(value) {
      this.$emit('updatedDateFrom', value)
    },
    dateTo(value) {
      this.$emit('updatedDateTo', value)
    },
    highwaysCatalog: {
      immediate: true,
      handler: 'fetchHighways'
    }
  },
  computed: {
    filteredData() {
      let { selectedHighway, source, dateTo, dateFrom } = this

    	dateFrom = dateFrom && moment(dateFrom)
    	dateTo = dateTo && moment(dateTo)

      const hi = this.selectedHighway

      let filteredSource = this.source
      /* we no filter in here now

      if (dateFrom) {
        filteredSource = filteredSource
          .filter(ePlan => ePlan.dateObjects.startDate.isSameOrAfter(dateFrom, 'day'))
      }

      if (dateTo) {
        filteredSource = filteredSource
          .filter(ePlan => ePlan.dateObjects.finishDate.isSameOrBefore(dateTo, 'day'))
      }
      */

      if (selectedHighway) {
        filteredSource = filteredSource
          .filter(ePlan => ePlan.highwayId == selectedHighway)
      }

      return filteredSource
    },
  },

  methods: {
    fetchReVis() {
      userService.fetchType('revi')
        .then((users) => {
          this.revis = users
        })
    },
    fetchHighways() {
      const { highwaysCatalog } = this

      const fetchPromise = !!highwaysCatalog
        ? Promise.resolve(highwaysCatalog)
        : catalogService.fetch('highway', { noStore: true })


      return fetchPromise
        .then(highways => this.highways = highways)
    }
  },
}
</script>

<style lang="scss" scoped>

.md-card-content:last-of-type {
  padding-bottom: 0px; 
}

.md-card .md-card-content {
  padding: 0px 15px;
  line-height: 1.75em;
  position: relative;
}

.md-field.md-focused label, .md-field.md-has-value label, .md-field.md-focused.md-has-value label {
  color: #6d6d6dab !important;
  font-weight: bold;
  font-size: 1.4rem;
}

.md-field.md-focused label, .md-field.md-field.md-has-value label {
  top: -1rem;
}
  .vdatetime {
    margin-left: 2em;
    margin-top: 1em;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/WorkPlan/WeeklyExecution/Filter.vue